import useCommonOrdersQueryCaa from "@repo/shopifyV2/queries/useOrdersQueryCaa";

import useLanguage from "@hooks/useLanguage";

import { caaRequest } from "@lib/caaClient";

export default function useOrdersCaa() {
  const { lang } = useLanguage();

  return useCommonOrdersQueryCaa({ request: caaRequest, enabled: lang === "jp", first: 10 });
}
